import * as React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import { connect } from 'react-redux';
// Bootstrap Imports
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
// React Table Imports
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import cellEditFactory from 'react-bootstrap-table2-editor';
// Component Imports
import Loader from '../../components/common/Loader';
// Function Imports
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { qsStringify } from '../../utilities/helper';
import Dialog from '../../utilities/Dialog'
import logger from '../../utilities/logging';

const url = "/api/portal/client"

class RegisteredClients extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            data : [],
            loading : true,
            isModalOpen : false,
            newClient : {
                PortalClientId : "",
                Description : "",
                TokenLifetimeSeconds : "",
                AllowedOrigin : "",
            },
            isDuplicateId : false,
            formsValid : false,
            changingClient : false,
            changingClientError : "",
            messageModalOpen : false,
            currentRow : null,
            currentIndex : null,
            disabledMessage : "",
        }
    }

    columns = [
        {
            dataField : "PortalClientId",
            text : "Portal Client Id",
            editable: false
        },
        {
            dataField : "TokenLifetimeSeconds",
            text : "Token Lifetime",
            editable: true
        },
        {
            dataField : "Description",
            text : "Description",
            editable : true
        },
        {
            dataField : "AllowedOrigin",
            text : "Allowed Origin",
            editable : true
        },
        {
            dataField : "CreatedDate",
            text : "Created Date",
            editable : false
        },
        {
            dataField : "CreatedBy",
            text : "Created By",
            editable : false
        },
        {
            dataField : "DeletedDate",
            text : "Deleted Date",
            editable : false
        },
        {
            dataField : "DisabledDate",
            text : "Disabled Date",
            editable : false
        },
        {
            dataField : "DisabledBy",
            text : "Disabled By",
            editable : false
        },
        {
            dataField : "DisabledMessage",
            text : "Disabled Message",
            editable : false
        },
        {
            isDummyField : true,
            dataField : "df-1",
            text : "Actions",
            formatter: (cell, row, rowIndex) => 
            <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                <i onClick={(e) => this.deleteRegisteredClient(e, row, rowIndex)} className="material-icons cursor-on-hover">delete</i>
                {
                    row.DisabledDate
                    ?<i onClick={e => this.enableRegisteredClient(e, row, rowIndex)} className="material-icons cursor-on-hover">restore</i>
                    :<i onClick={e => this.openMessageModal(e, row, rowIndex)} className="material-icons cursor-on-hover">not_interested</i>
                }
            </div>,
            headerFormatter: (column) => 
            <div className="w-100 d-flex justify-content-end">
                <i onClick={() => this.setState({ isModalOpen : true })} className="material-icons cursor-on-hover">add</i>
            </div>,
            headerStyle: (column, colIndex) => {
                return {
                    width : "65px"
                }
            },
            editable : false
        }
    ];

    componentDidMount(){
        this.getRegisteredClients();
    }

    getRegisteredClients = () => {
        this.setState({ loading : true });
        //console.log(process.env.REACT_APP_API_URL + url + "/*");
        axios.get(process.env.REACT_APP_API_URL + url + "/*", AxiosConfig.configValue())
        .then(response => {
            const { data } = response;
            //console.log("RCRC", data);
            this.setState({ data : data.clients, loading : false });
            //console.log("response.data", data);
        })
        .catch(error => {
            alert("There was an error getting registered clients");
            //console.log(error);
            logger.Error({
                EventMessage : `RegisteredClients -> getRegisteredClients -> Error : ${JSON.stringify(error)}`,
                EventCategory : "httprequest"
            });
            AxiosConfig.handleError(error);
        })
    }

    deleteRegisteredClient = async (e, row, rowIndex) => {
        e.preventDefault();
        let c = new Dialog({ message: `Are you sure you want to delete ${row.PortalClientId}?` });
        let answer = await c.show();
        if(answer){
            let d = new Date();
            let requestBody = {
                ...row,
                DeletedDate : d.toISOString(),
                DeletedBy : this.props.username,
            };
            //console.log(requestBody);
            axios.post(process.env.REACT_APP_API_URL + url, qsStringify(requestBody), AxiosConfig.configValue())
            .then(response => {
                //console.log(response);
                let copy = [...this.state.data];
                copy.splice(rowIndex, 1);
                this.setState({ data : copy });
            })
            .catch(error => {
                //console.log(error);
                //console.log(error.response.data);
                logger.Error({
                    EventMessage : `RegisteredClients -> deleteRegisteredClient -> Error : ${JSON.stringify(error)}`,
                    EventCategory : "httprequest"
                });
                AxiosConfig.handleError(error);
            })
        }
        
    }

    editRegisteredClient = (e) => {
        e.preventDefault();
    }

    disableRegisteredClient = e => {
        e.preventDefault();
        const { currentRow, currentIndex, disabledMessage } = this.state;
        if(currentRow && currentIndex !== null){
            let d = new Date();
            let requestBody = {
                ...currentRow,
                DisabledDate : d.toISOString(),
                DisabledBy : this.props.username,
                DisabledMessage : disabledMessage
            }
            axios.post(process.env.REACT_APP_API_URL + url, qsStringify(requestBody), AxiosConfig.configValue())
            .then(response => {
                //console.log(response);
                let copy = [...this.state.data];
                copy[currentIndex] = response.data;
                this.setState({ changingClient : false, messageModalOpen : false, data : copy });
            })
            .catch(error => {
                //console.log(error);
                logger.Error({
                    EventMessage : `RegisteredClients -> disableRegisteredClient -> Error : ${JSON.stringify(error)}`,
                    EventCategory : "httprequest"
                });
                AxiosConfig.handleError(error);
            })
        }
    }

    enableRegisteredClient = async (e, currentRow, currentIndex) => {
        e.preventDefault();
        if(currentRow && currentIndex !== null){
            let c = new Dialog({ message: "Are you sure you want to re-enable this client?" });
            let answer = await c.show();
            if(answer){
                let requestBody = {
                    ...currentRow,
                    DisabledDate : null,
                    DisabledBy : null,
                    DisabledMessage : null
                }
                axios.post(process.env.REACT_APP_API_URL + url, qsStringify(requestBody), AxiosConfig.configValue())
                .then(response => {
                    //console.log(response);
                    let copy = [...this.state.data];
                    copy[currentIndex] = response.data;
                    this.setState({ changingClient : false, messageModalOpen : false, data : copy });
                })
                .catch(error => {
                    //console.log(error);
                    logger.Error({
                        EventMessage : `RegisteredClients -> enableRegisteredClient -> Error : ${JSON.stringify(error)}`,
                        EventCategory : "httprequest"
                    });
                    AxiosConfig.handleError(error);
                })
            }
        }
    }

    addRegisteredClient = e => {
        e.preventDefault();
        this.setState({ changingClient : true });
        let requestBody = qsStringify(this.state.newClient);
        axios.post(process.env.REACT_APP_API_URL + "/api/portal/client", requestBody, AxiosConfig.configValue())
        .then(response => {
            //console.log(response);
            this.setState({
                changingClient : false, 
                changingClientError : "", 
                formsValid : false,
                newClient : {
                    PortalClientId : "",
                    Description : "",
                    TokenLifetimeSeconds : "",
                    AllowedOrigin : ""
                },
                data : [...this.state.data, response.data],
                isModalOpen : false
            });
        })
        .catch(error => {
            //console.log(error);
            this.setState({ changingClient : false});
            logger.Error({
                EventMessage : `RegisteredClients -> addRegisteredClient -> Error : ${JSON.stringify(error)}`,
                EventCategory : "httprequest"
            });
            AxiosConfig.handleError(error);
        })
    }

    changeHandler = e => {
        e.preventDefault();
        const finalState = {
            ...this.state.newClient, 
            [e.target.name] : e.target.value 
        };
        this.setState({ 
            newClient : finalState 
        })
        const { PortalClientId, TokenLifetimeSeconds, Description, AllowedOrigin } = finalState;
        if(PortalClientId && TokenLifetimeSeconds && Description && AllowedOrigin){
            this.setState({ formsValid : true });
        }
        if(e.target.name === "PortalClientId"){
            let matches = this.state.data.filter(client => client.PortalClientId === e.target.value);
            if(matches.length){
                this.setState({ isDuplicateId : true, formsValid : false })
            }else{
                this.setState({ isDuplicateId : false });
            }
        }
    }

    openMessageModal = (e, row, rowIndex) => {
        e.preventDefault();
        this.setState({ 
            messageModalOpen : true,
            currentRow : row,
            currentIndex : rowIndex
        });
    }

    render() { 
        const { data, loading, isModalOpen, formsValid, changingClient, changingClientError, newClient, messageModalOpen, disabledMessage, isDuplicateId } = this.state;
        return (
            <>
            <Container fluid>
                <ToolkitProvider
                    keyField="PortalClientId"
                    bootstrap4
                    data={data}
                    columns={this.columns}
                    search
                >
                    {
                        props => (
                            <div>
                                {/* controls go here */}
                                {
                                    loading
                                    ?
                                    <Loader title="Loading Clients..." />
                                    :
                                    <div className="w-100">
                                        <div className="w-100 my-2">
                                        </div>
                                        <BootstrapTable 
                                            {...props.baseProps}
                                            hover={true}
                                            condensed={true}
                                            noDataIndication={ () => <h5 className="p-2">No Registered Clients Found...</h5>}
                                            cellEdit={
                                                cellEditFactory({ 
                                                mode: 'click',
                                                beforeSaveCell : (oldValue, newValue, row, column, done) => {
                                                    let requestBody = qsStringify({
                                                        PortalClientId : row.PortalClientId,
                                                        TokenLifetimeSeconds : row.TokenLifetimeSeconds,
                                                        Description : row.Description,
                                                    });
                                                    axios.post(process.env.REACT_APP_API_URL + url, requestBody, AxiosConfig.configValue())
                                                    .then(response => {
                                                        //console.log(response);
                                                        done();
                                                    })
                                                    .catch(error => {
                                                        //console.log(error.response.data);
                                                        const { Message } = error.response.data;
                                                        alert(Message);
                                                        done(false);
                                                    })
                                                    return { async : true };
                                                }
                                                })
                                            }
                                        />
                                    </div>
                                }
                            </div>
                        )
                    }
                </ToolkitProvider>
            </Container>

            {/* Disabled Message Modal */}
            <Modal show={messageModalOpen} onHide={() => this.setState({ messageModalOpen : false })} className="z-100">
                <Modal.Header>
                    <Modal.Title>Message (optional)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Disabled Message</Form.Label>
                        <Form.Control 
                            type="text"
                            name="DisabledMessage"
                            value={disabledMessage}
                            onChange={(e) => this.setState({ disabledMessage : e.target.value })}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => this.setState({ messageModalOpen : false })} variant="secondary">Close/Cancel</Button>
                    <Button disabled={changingClient} onClick={this.disableRegisteredClient} variant="primary">Continue</Button>
                </Modal.Footer>
            </Modal>

            {/* Add user modal */}
            <Modal show={isModalOpen} onHide={() => this.setState({ isModalOpen : false })} >
                <Modal.Header closeButton>
                    <Modal.Title>Add Client</Modal.Title>
                    {
                        changingClientError&&<Alert variant="danger">{changingClientError}</Alert>
                    }
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Portal Client Id</Form.Label>
                            <Form.Control
                                onChange={this.changeHandler}
                                name="PortalClientId"
                                type="text"
                                placeholder="Portal Client Id"
                                value={newClient.PortalClientId}
                                style={isDuplicateId ? { color : "red" } : {color : "black"}}
                                autocomplete="off"
                            />
                            <p className="text-danger">{isDuplicateId&&"Duplicate Client Id"}</p>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Description</Form.Label>
                            <Form.Control 
                                placeholder="Description"
                                onChange={this.changeHandler}
                                name="Description"
                                type="text"
                                value={newClient.Description}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Token Lifetime</Form.Label>
                            <Form.Control
                                onChange={this.changeHandler}
                                type="number"
                                name="TokenLifetimeSeconds"
                                placeholder="Token Lifetime"
                                value={newClient.TokenLifetimeSeconds}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Allowed Origin</Form.Label>
                            <Form.Control
                                onChange={this.changeHandler}
                                name="AllowedOrigin"
                                type="text"
                                placeholder="Allowed Origin"
                                value={newClient.AllowedOrigin}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => this.setState({ isModalOpen : false })} variant="secondary">Close</Button>
                    <Button onClick={this.addRegisteredClient} disabled={!formsValid || changingClient}>Add Client</Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    username : state.user.userName
})

export default connect(mapStateToProps)(RegisteredClients);

